import type {
  LeaseComp,
  LeaseCompFieldRule,
  LeaseCompsState,
} from "@/features/leaseComps/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: LeaseCompsState = {
  isLoading: false,
  error: null,
  leaseComps: [],
  fieldRules: [],
};

const leaseCompsSlice = createSlice({
  name: "leaseComps",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setLeaseComps: (state, action: PayloadAction<LeaseComp[]>) => {
      state.leaseComps = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setFieldRules: (state, action: PayloadAction<LeaseCompFieldRule[]>) => {
      state.fieldRules = action.payload;
    },
  },
});

export const { setLoading, setError, setLeaseComps, setFieldRules } =
  leaseCompsSlice.actions;

export default leaseCompsSlice.reducer;
